/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation IpDeleteMutation($ipId: ID!) {
  IpDelete(ipId: $ipId) {
    id
    message
    status
  }
}
`
